var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHalf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "256px",
    height: "256px",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#fbbd08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "grey"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#grad)",
    d: "M20.388,10.918L32,12.118l-8.735,7.749L25.914,31.4l-9.893-6.088L6.127,31.4l2.695-11.533L0,12.118l11.547-1.2L16.026,0.6L20.388,10.918z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHalf);
export default __webpack_public_path__ + "static/media/half.c8c69c2842f7956f12579d5915723da3.svg";
export { ForwardRef as ReactComponent };